import { logError } from "common/error";
import { load } from "common/loader";
import { OnEvent } from "common/onEvent";
import { cancel, delay } from "common/promises";
import { openingPaths } from "from-start/scene/resources";
import log from "loglevel";
import NoSleep from "nosleep.js";
export async function start(sound) {
    await load({
        filePaths: openingPaths,
    });
    const onOpening = new OnEvent({
        eventName: "stateChanged",
        selector: "jh-opening",
        filter: (ev) => {
            return ev.detail.newState === "opening";
        },
        hasFiredBefore: (elem) => elem.attr("state") === "opening",
    });
    $("jh-opening").attr("showPlaySoundPopup", "");
    $("jh-opening").attr("state", "opening");
    const jhOpeningElem = $("jh-opening")[0];
    await onOpening.waitOnce();
    sound.playLoop("openingBgm");
    await jhOpeningElem.playSoundPopupClosed.wait();
    const withCancel = cancel.root(showPopupLater(sound));
    log.trace("opening wait enter button");
    $(document).one("click", () => {
        const noSleep = new NoSleep();
        try {
            noSleep.enable();
        }
        catch (err) {
            logError(err);
        }
    });
    await buttonClick(sound, withCancel.canceler);
}
async function buttonClick(sound, onButtonClick) {
    const onClick = new OnEvent({
        eventName: "enterClick",
        selector: "jh-opening",
    });
    const onFinish = new OnEvent({
        eventName: "stateChanged",
        selector: "jh-opening",
        filter: (ev) => {
            return ev.detail.newState === "finished";
        },
        hasFiredBefore: (elem) => elem.attr("state") === "finished",
    });
    await onClick.waitOnce();
    onButtonClick.cancel();
    log.trace("opening onClick fired");
    sound.stopLoop("openingBgm");
    sound.play("openingEnter");
    await onFinish.waitOnce();
    log.trace("opening onFinish fired");
}
function showPopupLater(sound) {
    return async (canceler) => {
        canceler.check();
        await delay(4000);
        canceler.check();
        sound.play("openingPopup");
        $("jh-opening").attr("show-popup", "");
    };
}
//# sourceMappingURL=main.js.map